module.exports = __webpack_public_path__ + "static/media/loader.ac31d97e.svg";